export default "__VITE_ASSET__CZk4_p3a__"